import { Text, View } from "react-native";
import AttachmentViewer, { Attachment } from "../ui-kit/attachment-viewer";
import { useTranslation } from "react-i18next";

type GroupFilesProps = Readonly<{
	groupFiles: Attachment[]
}>

const GroupFiles = ({ groupFiles }: GroupFilesProps) => {
	const { t } = useTranslation();
	return (

		<View className="bg-chalk rounded-[16px] border border-ash-3 p-4 gap-4">
			<View className="flex-row justify-between items-center">
				<View>
					<Text className="text-[15px] font-bold text-onyx">
						{t("LABEL_FILES")}
					</Text>
					<Text className="text-xs text-ash-1 mt-0.5">
						{groupFiles.length}{" "}
						{groupFiles.length === 1
							? t("LABEL_FILE")
							: t("LABEL_FILES_COUNT")}
					</Text>
				</View>
			</View>

			<View className="h-px bg-ash-3" />

			{groupFiles.length ? (
				<AttachmentViewer
					attachments={groupFiles}
					previewHeight={120}
				/>
			) : (
				<View className="items-center py-10 gap-2">
					<Text className="text-base font-semibold text-onyx">
						{t("LABEL_NO_FILES")}
					</Text>
					<Text className="text-sm text-ash-1 text-center">
						{t("LABEL_NO_FILES_DESC")}
					</Text>
				</View>
			)}
		</View>
	);
}

export default GroupFiles;
